import {Federacion, FederacionJSON } from '../Federacion/Federacion';
export interface FederacionGestionAccionJSON {
    fga_id: string;
    fga_fedid: string;
    fga_planilla_digital_partido_iniciado_agregar_jugador: boolean;
    federacion: FederacionJSON;
}

export class FederacionGestionAccion {
    protected constructor(
    private id: string,
    private fedid: string,
    private planillaDigitalPartidoIniciadoAgregarJugador: boolean,
    private federacion: Federacion) {}

    static createFrom( id: string,
    fedid: string,
    planillaDigitalPartidoIniciadoAgregarJugador: boolean,
    federacion: Federacion) {
        return new this( id,
        fedid,
        planillaDigitalPartidoIniciadoAgregarJugador,
        federacion)
    }

    isIdentifiedBy(anId: string): boolean {
        return this.id === anId
    }

    isIdentifiedAs(aEntity: FederacionGestionAccion) {
        if(this.id){
            return aEntity.isIdentifiedBy(this.id)
        } else {
            return false
        }

    }

    static fromJSON(entity: FederacionGestionAccionJSON) {
        return FederacionGestionAccion.createFrom( entity.fga_id,
        entity.fga_fedid,
        entity.fga_planilla_digital_partido_iniciado_agregar_jugador,
        Federacion.fromJSON(entity.federacion))
    }

    toJSON(): FederacionGestionAccionJSON {
        return {
            fga_id: this.getId(),
            fga_fedid: this.getFedid(),
            fga_planilla_digital_partido_iniciado_agregar_jugador: this.getPlanillaDigitalPartidoIniciadoAgregarJugador(),
            federacion: this.getFederacion().toJSON()
        }

    }

    getId(): string { return this.id; }

    getFedid(): string { return this.fedid; }

    getPlanillaDigitalPartidoIniciadoAgregarJugador(): boolean { return this.planillaDigitalPartidoIniciadoAgregarJugador; }

    getFederacion(): Federacion{ return this.federacion; }

}

